<template>
    <LoginPage />
</template>

<script>
import LoginPage from '@/pages/LoginPage.vue'

export default {
  name: 'LoginView',
  components: {
    LoginPage
  }
}
</script>
